import { createApi } from '../shared/api';

/** Único cliente de la API del panel: el token vive con la clave del panel, no con la del portal. */
export const api = createApi('admin');

const NAME_KEY = 'provalia.admin.name';

/** Nombre de quien entró, solo para enseñarlo. La sesión de verdad es el token. */
export function sessionName(): string | null {
  try {
    return sessionStorage.getItem(NAME_KEY);
  } catch {
    return null;
  }
}

export function setSessionName(name: string | null): void {
  try {
    if (name === null) sessionStorage.removeItem(NAME_KEY);
    else sessionStorage.setItem(NAME_KEY, name);
  } catch {
    /* solo se pierde el nombre en pantalla */
  }
}

/** Tramo de URL de un cliente, ya escapado. */
export const tenantPath = (slug: string): string => `/admin/tenants/${encodeURIComponent(slug)}`;
